var map = {
	"./icon-arrow.svg": 5361,
	"./icon-arrow1.svg": 2594,
	"./icon-change.svg": 4134,
	"./icon-close.svg": 5686,
	"./icon-copy.svg": 8385,
	"./icon-edit.svg": 7038,
	"./icon-lfg.svg": 4015,
	"./icon-lock.svg": 9523,
	"./icon-ok.svg": 3480,
	"./icon-refresh.svg": 303,
	"./icon-telegram.svg": 9611,
	"./icon-x.svg": 2078,
	"./icon-youtube.svg": 8737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;